var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMorning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-72"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.85,
    y: 393.56,
    width: 10.48,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.93,
    y: 388.56,
    width: 40.25,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.18,
    y: 389.3,
    width: 59.15,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.97,
    y: 389.3,
    width: 17.03,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.44,
    y: 390.88,
    width: 54.6,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.22,
    y: 395,
    width: 22.56,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.88,
    y: 391.01,
    width: 14.31,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.72 263.55 328.9 263.55 334.25 382.4 420.08 382.4 414.72 263.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.97 263.55 330.14 263.55 335.5 382.4 421.32 382.4 415.97 263.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.3,
    y: 355.42,
    width: 22.52,
    height: 26.98,
    transform: "translate(711.11 737.82) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.81,
    y: 355.42,
    width: 82.29,
    height: 26.98,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.3,
    y: 358.87,
    width: 105.04,
    height: 1.85,
    transform: "translate(793.63 719.6) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.05,
    y: 354.3,
    width: 23.76,
    height: 5.35,
    transform: "translate(709.86 713.95) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.81,
    y: 354.3,
    width: 83.53,
    height: 5.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.76,
    y: 297.37,
    width: 34.21,
    height: 56.93,
    transform: "translate(737.74 651.67) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.97,
    y: 297.37,
    width: 41.79,
    height: 56.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.76,
    y: 302.62,
    width: 76.36,
    height: 2.81,
    transform: "translate(779.89 608.05) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.88,
    y: 290.87,
    width: 36.1,
    height: 12.93,
    transform: "translate(735.85 594.67) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.97,
    y: 290.87,
    width: 43.68,
    height: 12.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.91,
    cy: 360.47,
    r: 21.92,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65,347.41c-1.31-1.35-1.83-3-1.17-3.61s2.26-.06,3.56,1.3,1.83,3,1.17,3.6S342,348.76,340.65,347.41Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,343.3c-1.85-.36-3.2-1.38-3-2.28s1.81-1.35,3.66-1,3.2,1.37,3,2.27S333.39,343.65,331.54,343.3Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41,351c-1.77-.62-2.9-2-2.52-3.1s2.13-1.47,3.9-.84,2.91,2,2.52,3.1S335.18,351.57,333.41,351Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.34,
    y: 73.68,
    width: 251.58,
    height: 144.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.09,
    y: 73.68,
    width: 253.57,
    height: 144.13,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.69,
    y: 24.19,
    width: 132.36,
    height: 243.1,
    transform: "translate(336.61 -45.13) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.27 211.92 163.02 79.56 203.32 79.56 172.57 211.92 132.27 211.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.1 211.92 209.84 79.56 228.04 79.56 197.3 211.92 179.1 211.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.91,
    y: 145.41,
    width: 132.36,
    height: 0.67,
    transform: "translate(457.83 -166.35) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.41,73.44v57.12H73.52s27.15-17.71,33.32-54.14a6.07,6.07,0,0,0-6-7.09H62.52A4.11,4.11,0,0,0,58.41,73.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.41,237.67V135.17H73.52s30.66,61.28,34.22,102.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.45,
    y: 130.56,
    width: 17.14,
    height: 4.61,
    rx: 1.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,73.44v57.12H306.83s-27.15-17.71-33.32-54.14a6.06,6.06,0,0,1,6-7.09h38.36A4.11,4.11,0,0,1,321.94,73.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,237.67V135.17H306.83s-30.67,61.28-34.23,102.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.76,
    y: 130.56,
    width: 17.14,
    height: 4.61,
    rx: 1.51,
    transform: "translate(628.65 265.72) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.64,
    y: 289.11,
    width: 21.33,
    height: 93.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.73 382.4 251.97 382.4 251.97 366.92 233.04 366.92 242.73 382.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.16,
    y: 289.11,
    width: 21.33,
    height: 93.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.43,
    y: 289.11,
    width: 173.54,
    height: 87.96,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.66 382.4 78.43 382.4 78.43 366.92 97.35 366.92 87.66 382.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.59,
    y: 296.51,
    width: 159.21,
    height: 32.44,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,312.74a4.89,4.89,0,1,0,4.89-4.9A4.89,4.89,0,0,0,160.31,312.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.59,
    y: 336.79,
    width: 159.21,
    height: 32.44,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,353a4.89,4.89,0,1,0,4.89-4.89A4.89,4.89,0,0,0,160.31,353Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.58,
    y: 92.95,
    width: 71.67,
    height: 109.88,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.24,
    y: 92.95,
    width: 76.07,
    height: 109.88,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.19,
    y: 114.71,
    width: 100.18,
    height: 66.37,
    transform: "translate(540.17 -244.38) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.76,
    y: 126.39,
    width: 75.05,
    height: 43.01,
    transform: "translate(540.17 -244.38) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-72"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.5,255.06c0,1.22-.58,1-1,1.19l-1.23.4-2.44.81c-1.65.51-3.28,1-4.93,1.53-3.29,1-6.61,1.92-10,2.69a.5.5,0,0,1-.6-.38.52.52,0,0,1,.28-.57c3.15-1.43,6.34-2.71,9.56-3.93,1.61-.61,3.23-1.19,4.84-1.78l2.44-.84,1.21-.43c.43-.07.71-.59,1.49.36A1.48,1.48,0,0,1,203.5,255.06Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,255.06c0,1.22-.58,1-1,1.19l-1.23.4-2.44.81c-1.65.51-3.28,1-4.93,1.53-3.29,1-6.61,1.92-10,2.69a.5.5,0,0,1-.6-.38.52.52,0,0,1,.28-.57c3.15-1.43,6.34-2.71,9.56-3.93,1.61-.61,3.23-1.19,4.84-1.78l2.44-.84,1.21-.43c.43-.07.71-.59,1.49.36A1.48,1.48,0,0,1,203.5,255.06Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,258.33s-.37,11.15-14.27,11.15-14.28-11.15-14.28-11.15Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.72,258.33s-.37,11.15-14.27,11.15-14.28-11.15-14.28-11.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M267.23,253.83a5.32,5.32,0,0,0-.56.06v-1.26a1.58,1.58,0,0,0-1.58-1.58H252.76a1.59,1.59,0,0,0-1.59,1.58V268.4a1.08,1.08,0,0,0,1.08,1.08H265.6a1.07,1.07,0,0,0,1.07-1.08v-1.76a5.29,5.29,0,0,0,.56.05A4.67,4.67,0,0,0,271.9,262V258.5A4.68,4.68,0,0,0,267.23,253.83Zm2.67,8.2a2.67,2.67,0,0,1-2.67,2.66,2.6,2.6,0,0,1-.56-.06v-8.74a3.43,3.43,0,0,1,.56-.06,2.68,2.68,0,0,1,2.67,2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.71,232.24a10,10,0,0,1,.92,4.43,13.06,13.06,0,0,1-.92,4.38c-.49,1.31-1,2.44-1.43,3.68s-.89,2.55-1.56,3.94a.14.14,0,0,1-.18.07.12.12,0,0,1-.07-.07,10.26,10.26,0,0,1-.89-4.42,13.6,13.6,0,0,1,.88-4.38c.47-1.32,1-2.45,1.4-3.69a40.37,40.37,0,0,1,1.6-3.94.14.14,0,0,1,.18-.06S259.69,232.22,259.71,232.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,227a9.88,9.88,0,0,1,.92,4.43,13.05,13.05,0,0,1-.91,4.38c-.49,1.3-1,2.44-1.43,3.68s-.9,2.55-1.57,3.94a.14.14,0,0,1-.18.07.23.23,0,0,1-.07-.07,10.56,10.56,0,0,1-.89-4.42,13.55,13.55,0,0,1,.89-4.38c.47-1.32.94-2.45,1.4-3.69a40.16,40.16,0,0,1,1.59-3.94.13.13,0,0,1,.18-.06A.14.14,0,0,1,266.49,227Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.36,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(202.76 692.16) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.29,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.03,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.29,
    y: 269.48,
    width: 202.78,
    height: 6.45,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.32,
    y: 269.48,
    width: 53.97,
    height: 6.45,
    transform: "translate(238.62 545.4) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92.32,
    y: 269.48,
    width: 53.97,
    height: 6.45,
    transform: "translate(238.62 545.4) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 92.32,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.32,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.25,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(286.55 692.16) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.25,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(286.55 692.16) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.78,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(583.59 692.16) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.78,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(583.59 692.16) rotate(180)",
    style: {
      fill: "#4080FF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.78,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(583.59 692.16) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.99,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(680.02 692.16) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.99,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(680.02 692.16) rotate(180)",
    style: {
      fill: "#4080FF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.99,
    y: 275.92,
    width: 6.04,
    height: 140.31,
    transform: "translate(680.02 692.16) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.46,
    y: 215.77,
    width: 42.43,
    height: 53.7,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.46,
    y: 230.44,
    width: 32.43,
    height: 24.37,
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.46,
    y: 230.44,
    width: 32.43,
    height: 24.37,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.01,
    y: 215.77,
    width: 10.44,
    height: 53.7,
    transform: "translate(262.47 485.25) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.01,
    y: 215.77,
    width: 10.44,
    height: 53.7,
    transform: "translate(262.47 485.25) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.01 215.77 136.46 215.77 134.33 212.15 123.89 212.15 126.01 215.77",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.01 215.77 136.46 215.77 134.33 212.15 123.89 212.15 126.01 215.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.89 215.77 168.44 215.77 170.57 212.15 181.01 212.15 178.89 215.77",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.89 215.77 168.44 215.77 170.57 212.15 181.01 212.15 178.89 215.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.83,184.32V182a3.44,3.44,0,0,1,6.1-2.2A7.56,7.56,0,0,0,210.83,184.32Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.83,184.32V182a3.44,3.44,0,0,1,6.1-2.2A7.56,7.56,0,0,0,210.83,184.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.42,181.06a4,4,0,0,0,2.84,4.86l2-7.7A4,4,0,0,0,214.42,181.06Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.42,181.06a4,4,0,0,0,2.84,4.86l2-7.7A4,4,0,0,0,214.42,181.06Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,253.2h0a.29.29,0,0,1-.29-.29V184.74a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v68.17A.29.29,0,0,1,214.33,253.2Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,253.2h0a.29.29,0,0,1-.29-.29V184.74a.29.29,0,0,1,.29-.29h0a.29.29,0,0,1,.29.29v68.17A.29.29,0,0,1,214.33,253.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.74,187.33a3.46,3.46,0,0,1-6.91,0v-3a7.56,7.56,0,0,1,6.1-4.49,3.42,3.42,0,0,1,.81,2.2Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.74,187.33a3.46,3.46,0,0,1-6.91,0v-3a7.56,7.56,0,0,1,6.1-4.49,3.42,3.42,0,0,1,.81,2.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,181.55a4,4,0,0,1-2.85,4.86l-2-7.7A4,4,0,0,1,213.87,181.55Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,181.55a4,4,0,0,1-2.85,4.86l-2-7.7A4,4,0,0,1,213.87,181.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1,183.1a2.56,2.56,0,0,1,3.56-.67l-2.89,4.23A2.56,2.56,0,0,1,216.1,183.1Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1,183.1a2.56,2.56,0,0,1,3.56-.67l-2.89,4.23A2.56,2.56,0,0,1,216.1,183.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06,198.85l3.36,3.84a3.71,3.71,0,0,1,.91,2.44V211l-4.6-5.26a3.69,3.69,0,0,1-.91-2.44v-4A.71.71,0,0,1,210.06,198.85Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06,198.85l3.36,3.84a3.71,3.71,0,0,1,.91,2.44V211l-4.6-5.26a3.69,3.69,0,0,1-.91-2.44v-4A.71.71,0,0,1,210.06,198.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6,206.85l-3.35,3.84a3.72,3.72,0,0,0-.92,2.44V219l4.6-5.26a3.7,3.7,0,0,0,.92-2.44v-4A.71.71,0,0,0,218.6,206.85Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6,206.85l-3.35,3.84a3.72,3.72,0,0,0-.92,2.44V219l4.6-5.26a3.7,3.7,0,0,0,.92-2.44v-4A.71.71,0,0,0,218.6,206.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,250c-.44-11.33-3.45-15.31-.74-26.76h-5.51c2.7,11.45-.3,15.43-.75,26.76s-1.09,19.48,3.5,19.48S218.28,261.33,217.83,250Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.11,416.31a1.36,1.36,0,0,1-1.34-1.18l-12.26-93.47H323.08l-12.26,93.47a1.36,1.36,0,1,1-2.69-.35l12.42-94.65a1.35,1.35,0,0,1,1.34-1.18H344.7a1.35,1.35,0,0,1,1.34,1.18l12.42,94.65a1.35,1.35,0,0,1-1.17,1.52Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.11,416.31a1.36,1.36,0,0,1-1.34-1.18l-12.26-93.47H323.08l-12.26,93.47a1.36,1.36,0,1,1-2.69-.35l12.42-94.65a1.35,1.35,0,0,1,1.34-1.18H344.7a1.35,1.35,0,0,1,1.34,1.18l12.42,94.65a1.35,1.35,0,0,1-1.17,1.52Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.43,416.31a1.36,1.36,0,0,1-1.34-1.18l-12.27-93.47H357.4l-12.27,93.47a1.36,1.36,0,1,1-2.69-.35l12.42-94.65a1.36,1.36,0,0,1,1.35-1.18H379a1.34,1.34,0,0,1,1.34,1.18l12.42,94.65a1.35,1.35,0,0,1-1.16,1.52Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.43,416.31a1.36,1.36,0,0,1-1.34-1.18l-12.27-93.47H357.4l-12.27,93.47a1.36,1.36,0,1,1-2.69-.35l12.42-94.65a1.36,1.36,0,0,1,1.35-1.18H379a1.34,1.34,0,0,1,1.34,1.18l12.42,94.65a1.35,1.35,0,0,1-1.16,1.52Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62,320.3h45.16a15.83,15.83,0,0,0,15.83-15.51l1.69-68.63a11.54,11.54,0,0,0-11.54-11.77H358.45A11.54,11.54,0,0,0,347,234.62Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62,320.3h45.16a15.83,15.83,0,0,0,15.83-15.51l1.69-68.63a11.54,11.54,0,0,0-11.54-11.77H358.45A11.54,11.54,0,0,0,347,234.62Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,309.69h59a2.77,2.77,0,0,1,2.77,2.77v.26a7.59,7.59,0,0,1-7.59,7.59H304a0,0,0,0,1,0,0V309.69A0,0,0,0,1,304,309.69Z",
    transform: "translate(669.87 629.99) rotate(180)",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,309.69h59a2.77,2.77,0,0,1,2.77,2.77v.26a7.59,7.59,0,0,1-7.59,7.59H304a0,0,0,0,1,0,0V309.69A0,0,0,0,1,304,309.69Z",
    transform: "translate(669.87 629.99) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,163c-2-2.83-19.28-5.67-25.9,5.33s4.07,51.72-9.83,57.13c11.11,9.71,49.73,18.87,46.86-13.54C364.71,189,372.56,166.56,355.62,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.96 405.62 312.56 405.62 309.21 381.53 319.61 381.53 322.96 405.62",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.71 405.62 272.31 405.62 270.71 381.53 281.11 381.53 282.71 405.62",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.71 381.54 271.53 393.95 281.94 393.95 281.12 381.54 270.71 381.54",
    style: {
      fill: "#db9792"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.62 381.54 309.21 381.54 310.94 393.95 321.35 393.95 319.62 381.54",
    style: {
      fill: "#db9792"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.6,279.13s-69.74,6.49-69.06,38.21c.71,33,7.77,74.21,7.77,74.21h14.4s1.24-34.88,1.65-67.36c.22-16.93,67.61-20.32,67.61-20.32l8.7-24.74Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.6,279.13s-69.74,6.49-69.06,38.21c.71,33,7.77,74.21,7.77,74.21h14.4s1.24-34.88,1.65-67.36c.22-16.93,67.61-20.32,67.61-20.32l8.7-24.74Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.89,229.72c-.14.77-.26,1.31-.4,1.94s-.29,1.2-.44,1.8c-.31,1.18-.63,2.35-1,3.51-.67,2.31-1.45,4.59-2.27,6.83-1.64,4.5-3.51,8.87-5.56,13.16l-.78,1.6-.4.81a12.86,12.86,0,0,1-.66,1.2,12,12,0,0,1-3.95,3.94,13.81,13.81,0,0,1-4.79,1.79,19.33,19.33,0,0,1-4.44.21,29.63,29.63,0,0,1-7.72-1.68c-1.19-.41-2.34-.91-3.47-1.43a34.73,34.73,0,0,1-3.35-1.75l2.18-4.91c4.12,1,8.68,1.74,12.36,1.4a7.3,7.3,0,0,0,4-1.37,3.33,3.33,0,0,0,.75-1.08l1.05-2.71c1.62-4.21,3.16-8.45,4.54-12.71.71-2.13,1.34-4.27,2-6.39.32-1.06.61-2.12.89-3.18l.41-1.57.35-1.45Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,256.94l-6-6.06-2.16,10.35a14.4,14.4,0,0,0,7.91.59Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.91,404.41H323.6a.83.83,0,0,1,.83.71l1.33,9.25a1.67,1.67,0,0,1-1.67,1.85c-4.07-.07-6-.31-11.18-.31-3.16,0-11.27.33-15.63.33s-4.6-4.32-2.78-4.71c8.15-1.75,12.93-4.17,15.67-6.48A2.77,2.77,0,0,1,311.91,404.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,404.41h11.68a.82.82,0,0,1,.83.71l1.34,9.25a1.68,1.68,0,0,1-1.67,1.85c-4.08-.07-6-.31-11.18-.31-3.16,0-9.7.33-14.06.33s-4.6-4.32-2.78-4.71c8.15-1.75,11.35-4.17,14.1-6.48A2.77,2.77,0,0,1,271.5,404.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.83 391.84 268.19 391.84 266.96 386.04 285.36 384.75 284.83 391.84",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.35,406.16a2.84,2.84,0,0,1-1.93-.53,1.33,1.33,0,0,1-.39-1.24.79.79,0,0,1,.45-.64c1.18-.53,4.3,1.49,4.66,1.72a.2.2,0,0,1,.07.18.17.17,0,0,1-.13.14A12.78,12.78,0,0,1,308.35,406.16ZM307,404a1,1,0,0,0-.35.06.41.41,0,0,0-.24.37,1,1,0,0,0,.27.94c.56.51,2,.57,3.94.16A9.76,9.76,0,0,0,307,404Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,405.79a.15.15,0,0,1-.09,0c-1.09-.62-2.82-2.83-2.61-3.9a.78.78,0,0,1,.77-.63,1.18,1.18,0,0,1,1,.31c1.11,1,1.12,3.94,1.12,4.07a.18.18,0,0,1-.08.15Zm-1.77-4.21h-.12c-.36.05-.44.23-.47.36-.16.8,1.21,2.62,2.18,3.35,0-.79-.21-2.78-1-3.48A.83.83,0,0,0,309.27,401.58Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59,406.16a3.87,3.87,0,0,1-2.47-.62,1.31,1.31,0,0,1-.42-1.14.7.7,0,0,1,.38-.6c1.24-.68,5.35,1.42,5.82,1.66a.17.17,0,0,1,.09.18.17.17,0,0,1-.14.15A18.08,18.08,0,0,1,267.59,406.16ZM265.75,404a1,1,0,0,0-.5.1.35.35,0,0,0-.2.32.93.93,0,0,0,.3.85c.67.6,2.49.69,4.93.26A14.28,14.28,0,0,0,265.75,404Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.82,405.79h-.07c-1.23-.56-3.65-2.76-3.46-3.91,0-.25.22-.57.86-.63a1.71,1.71,0,0,1,1.31.41c1.29,1.07,1.52,3.84,1.53,4a.16.16,0,0,1-.07.16A.19.19,0,0,1,270.82,405.79Zm-2.48-4.21h-.15c-.51.05-.54.28-.56.35-.12.77,1.66,2.65,3,3.39-.1-.75-.44-2.63-1.37-3.41A1.39,1.39,0,0,0,268.34,401.58Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.75,279.13s-45.07,14.95-46.2,33.45c-2.1,34.06,12.88,79,12.88,79h14.18s-.8-29.8-2.5-60.66c-2.13-38.77,66.29-.53,52.73-51.76Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.75,279.13s-45.07,14.95-46.2,33.45c-2.1,34.06,12.88,79,12.88,79h14.18s-.8-29.8-2.5-60.66c-2.13-38.77,66.29-.53,52.73-51.76Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.75 391.84 307.11 391.84 305.88 386.04 324.2 385.8 323.75 391.84",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.47,276.66l.34,3.78c.15.29-.2.59-.69.59H330.39c-.38,0-.7-.19-.72-.43l-.38-3.78c0-.26.3-.48.72-.48h42.78A.75.75,0,0,1,373.47,276.66Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.73,281.44h1.14c.23,0,.41-.12.39-.26l-.54-4.92c0-.14-.21-.26-.44-.26h-1.15c-.22,0-.4.12-.38.26l.54,4.92C367.3,281.32,367.5,281.44,367.73,281.44Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.61,281.44h1.14c.23,0,.41-.12.39-.26l-.54-4.92c0-.14-.21-.26-.44-.26H333c-.22,0-.4.12-.38.26l.54,4.92C333.18,281.32,333.38,281.44,333.61,281.44Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.67,281.44h1.15c.22,0,.4-.12.38-.26l-.54-4.92c0-.14-.21-.26-.44-.26h-1.15c-.22,0-.4.12-.38.26l.54,4.92C350.24,281.32,350.44,281.44,350.67,281.44Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.73,281.44h1.14c.23,0,.41-.12.39-.26l-.54-4.92c0-.14-.21-.26-.44-.26h-1.15c-.22,0-.4.12-.38.26l.54,4.92C367.3,281.32,367.5,281.44,367.73,281.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.61,281.44h1.14c.23,0,.41-.12.39-.26l-.54-4.92c0-.14-.21-.26-.44-.26H333c-.22,0-.4.12-.38.26l.54,4.92C333.18,281.32,333.38,281.44,333.61,281.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.67,281.44h1.15c.22,0,.4-.12.38-.26l-.54-4.92c0-.14-.21-.26-.44-.26h-1.15c-.22,0-.4.12-.38.26l.54,4.92C350.24,281.32,350.44,281.44,350.67,281.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.63,216.36c-4.29,1.09-7.29,18.73-7.29,18.73l11.82,8s11.32-17.79,8-22.51C334.75,215.71,331.88,214.76,325.63,216.36Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.63,216.36c-4.29,1.09-7.29,18.73-7.29,18.73l11.82,8s11.32-17.79,8-22.51C334.75,215.71,331.88,214.76,325.63,216.36Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.63,216.36s-5,1.74,5,62.77h42.24c-.71-17.19-.73-27.79,7.49-63.07a124.45,124.45,0,0,0-17.94-2.37,134.77,134.77,0,0,0-19.18,0C335,214.45,325.63,216.36,325.63,216.36Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.63,216.36s-5,1.74,5,62.77h42.24c-.71-17.19-.73-27.79,7.49-63.07a124.45,124.45,0,0,0-17.94-2.37,134.77,134.77,0,0,0-19.18,0C335,214.45,325.63,216.36,325.63,216.36Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.68,258.09a98.16,98.16,0,0,0-2.33-15.54c-1.12-5-2.42-9.86-4-14.79L374,231c1.33,4.59,2.65,9.36,3.83,14a116.68,116.68,0,0,1,2.83,13.85c.1.78.17,1.58.2,2.29a14.38,14.38,0,0,1-2.08-.58,54,54,0,0,1-6.3-2.78c-1.06-.54-2.14-1.09-3.2-1.67l-3.15-1.75-3.35,4.21a55.17,55.17,0,0,0,12.56,9.7,21.44,21.44,0,0,0,4.28,1.75,12,12,0,0,0,2.91.42,9.93,9.93,0,0,0,1.88-.17,7.89,7.89,0,0,0,2.17-.8,7.47,7.47,0,0,0,2-1.62,7.58,7.58,0,0,0,1.25-2,10.25,10.25,0,0,0,.83-3.45A37.64,37.64,0,0,0,390.68,258.09Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.49,192.09c-1.21,6.18-2.42,17.48,1.9,21.6,0,0-1.69,6.26-13.15,6.26-12.61,0-6-6.26-6-6.26,6.88-1.64,6.7-6.75,5.51-11.54Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.69,196.2l-7,5.94a19.65,19.65,0,0,1,.59,3.41c2.63-.38,6.24-3.27,6.52-6A9.3,9.3,0,0,0,355.69,196.2Z",
    style: {
      fill: "#db9792"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.81,174.89c2.25,10.07,3.42,14.29-.12,20.81-5.31,9.82-18.18,10.38-23.39,1.17-4.7-8.28-7.58-23.36,1-30.1A14.08,14.08,0,0,1,359.81,174.89Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.94,167.39c-.5,5.72,7.76,19.16,13.48,14.87s-1.31-14.59-1.31-14.59l-6.88-3.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.72,165.28c-2.84,8.51-20,11.68-24.55,11.11,2.5-8.28,6.29-13.56,12-14.5S354.72,165.28,354.72,165.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,183.65a7.52,7.52,0,0,1-2.27,5.3c-1.9,1.83-4.1.43-4.62-2-.46-2.21,0-5.82,2.38-6.73S365,181.2,365,183.65Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59,182c.24.8,0,1.58-.53,1.73s-1.14-.38-1.38-1.18,0-1.58.54-1.74S345.36,181.18,345.59,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.48,184.62c.23.8,0,1.58-.53,1.73s-1.14-.38-1.38-1.18,0-1.59.54-1.74S336.25,183.81,336.48,184.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.35,183.41h-2.09S334.68,184.64,335.35,183.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,185.31a22.53,22.53,0,0,1-1.39,6,3.6,3.6,0,0,0,3-.29Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,193.27a.17.17,0,0,1-.15-.12.16.16,0,0,1,.11-.19,6.72,6.72,0,0,0,4.55-4.06.15.15,0,0,1,.19-.1.15.15,0,0,1,.11.19,7.07,7.07,0,0,1-4.76,4.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,177.76a.32.32,0,0,1-.18-.06,4.84,4.84,0,0,0-4.25-.7.31.31,0,1,1-.23-.58,5.38,5.38,0,0,1,4.84.77.31.31,0,0,1,.08.44A.33.33,0,0,1,346.86,177.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,182.38a.23.23,0,0,1-.11,0,.31.31,0,0,1-.18-.4,4.7,4.7,0,0,1,3.15-3,.31.31,0,0,1,.37.24.32.32,0,0,1-.24.38,4.07,4.07,0,0,0-2.69,2.57A.32.32,0,0,1,331,182.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46,180.78h-2.09S343.8,182,344.46,180.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,213.78l46.91-3.41,14.84,73.94-46.67,3.4a.29.29,0,0,1-.3-.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,287.67l-30.08-5.83L275.8,207.9l30.44,5.9L321,287.38A.24.24,0,0,1,320.69,287.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.79 230.89 281.25 225.75 278.44 211.72 304.98 216.87 307.79 230.89",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.83 244.67 284.56 242.29 281.75 228.27 294.02 230.64 296.83 244.67",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.57 234.8 295.91 232.35 295.63 230.95 308.29 233.41 308.57 234.8",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.41 239.01 296.75 236.56 296.47 235.17 309.13 237.62 309.41 239.01",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.26 243.22 297.59 240.77 297.31 239.38 309.98 241.83 310.26 243.22",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.1 247.44 298.44 244.98 298.16 243.59 310.82 246.04 311.1 247.44",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.06 252.25 285.53 247.11 285.25 245.72 311.79 250.86 312.06 252.25",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.91 256.46 286.37 251.32 286.09 249.93 312.63 255.07 312.91 256.46",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.75 260.67 287.21 255.53 286.94 254.14 313.47 259.28 313.75 260.67",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.28 273.31 310.96 272.28 309 262.46 314.32 263.49 316.28 273.31",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.58 263.53 288.06 259.74 287.78 258.35 307.3 262.13 307.58 263.53",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.43 267.74 288.9 263.96 288.62 262.56 308.15 266.35 308.43 267.74",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.27 271.95 289.74 268.17 289.46 266.77 308.99 270.56 309.27 271.95",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.13 277.52 290.59 272.38 290.31 270.99 316.85 276.13 317.13 277.52",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 283.92 291.87 278.77 291.02 274.55 317.56 279.69 318.41 283.92",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "307.79 230.89 281.25 225.75 278.44 211.72 304.98 216.87 307.79 230.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.83 244.67 284.56 242.29 281.75 228.27 294.02 230.64 296.83 244.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.57 234.8 295.91 232.35 295.63 230.95 308.29 233.41 308.57 234.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.41 239.01 296.75 236.56 296.47 235.17 309.13 237.62 309.41 239.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.26 243.22 297.59 240.77 297.31 239.38 309.98 241.83 310.26 243.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.1 247.44 298.44 244.98 298.16 243.59 310.82 246.04 311.1 247.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.06 252.25 285.53 247.11 285.25 245.72 311.79 250.86 312.06 252.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.91 256.46 286.37 251.32 286.09 249.93 312.63 255.07 312.91 256.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.75 260.67 287.21 255.53 286.94 254.14 313.47 259.28 313.75 260.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.28 273.31 310.96 272.28 309 262.46 314.32 263.49 316.28 273.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.58 263.53 288.06 259.74 287.78 258.35 307.3 262.13 307.58 263.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.43 267.74 288.9 263.96 288.62 262.56 308.15 266.35 308.43 267.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.27 271.95 289.74 268.17 289.46 266.77 308.99 270.56 309.27 271.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.13 277.52 290.59 272.38 290.31 270.99 316.85 276.13 317.13 277.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 283.92 291.87 278.77 291.02 274.55 317.56 279.69 318.41 283.92",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "320.01 270.04 360.9 267.06 363.71 281.08 322.82 284.06 320.01 270.04",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.67 251.89 357.58 250.52 360.39 264.54 341.49 265.92 338.67 251.89",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.22 266.13 338.74 264.71 339.02 266.1 319.5 267.52 319.22 266.13",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.38 261.92 337.89 260.5 338.17 261.89 318.66 263.31 318.38 261.92",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.53 257.7 337.05 256.28 337.33 257.68 317.81 259.1 317.53 257.7",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.69 253.49 336.2 252.07 336.48 253.47 316.97 254.89 316.69 253.49",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.72 248.68 356.62 245.7 356.89 247.09 316 250.07 315.72 248.68",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.88 244.47 355.77 241.49 356.05 242.88 315.16 245.86 314.88 244.47",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.03 240.25 354.93 237.28 355.2 238.67 314.31 241.65 314.03 240.25",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.5 227.62 319.69 227.02 321.66 236.84 313.47 237.44 311.5 227.62",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.99 235.26 354.08 233.06 354.36 234.46 324.27 236.65 323.99 235.26",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.15 231.04 353.24 228.85 353.51 230.25 323.43 232.44 323.15 231.04",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.3 226.83 352.39 224.64 352.67 226.03 322.58 228.23 322.3 226.83",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.65 223.41 351.55 220.43 351.82 221.82 310.93 224.8 310.65 223.41",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.37 217.01 350.26 214.03 351.11 218.26 310.22 221.24 309.37 217.01",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.01 270.04 360.9 267.06 363.71 281.08 322.82 284.06 320.01 270.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.67 251.89 357.58 250.52 360.39 264.54 341.49 265.92 338.67 251.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.22 266.13 338.74 264.71 339.02 266.1 319.5 267.52 319.22 266.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.38 261.92 337.89 260.5 338.17 261.89 318.66 263.31 318.38 261.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.53 257.7 337.05 256.28 337.33 257.68 317.81 259.1 317.53 257.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.69 253.49 336.2 252.07 336.48 253.47 316.97 254.89 316.69 253.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.72 248.68 356.62 245.7 356.89 247.09 316 250.07 315.72 248.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.88 244.47 355.77 241.49 356.05 242.88 315.16 245.86 314.88 244.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.03 240.25 354.93 237.28 355.2 238.67 314.31 241.65 314.03 240.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.5 227.62 319.69 227.02 321.66 236.84 313.47 237.44 311.5 227.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.99 235.26 354.08 233.06 354.36 234.46 324.27 236.65 323.99 235.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.15 231.04 353.24 228.85 353.51 230.25 323.43 232.44 323.15 231.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.3 226.83 352.39 224.64 352.67 226.03 322.58 228.23 322.3 226.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.65 223.41 351.55 220.43 351.82 221.82 310.93 224.8 310.65 223.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.37 217.01 350.26 214.03 351.11 218.26 310.22 221.24 309.37 217.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.72,255.53l-8.17-6.07.73,10.55s6.06,2.81,9.52.21Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.81 249.74 351.9 258.54 360.28 260.01 359.56 249.46 350.81 249.74",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.51 248.78 281.17 257.55 288.84 261.23 291 250.88 282.51 248.78",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,216c4.23,1.29,9.31,15.86,9.31,15.86l-16.42,11.74s-6-12.17-4.21-17.64C371.06,220.23,375.7,214.49,380.53,216Z",
    style: {
      fill: "#4080FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,216c4.23,1.29,9.31,15.86,9.31,15.86l-16.42,11.74s-6-12.17-4.21-17.64C371.06,220.23,375.7,214.49,380.53,216Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMorning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/morning.3e92c1bc5d830c15440dbb7e6cbb0d90.svg";